import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { NgxSelectModule } from 'ngx-select-ex';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
// import { // Ng2TableModule, } from 'ng2-table/ng2-table';
import { RouterModule } from '@angular/router';
import { PosHeaderComponent } from './pos-header/pos-header.component';
import { PosFooterComponent } from './pos-footer/pos-footer.component';
import { routes } from '../../routes/routes';
import { PoslayoutComponent } from './poslayout.component';
import { PosSidebarComponent } from './pos-sidebar/pos-sidebar.component';
import { LayoutModule } from 'src/app/layout/layout.module';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [              
      PosHeaderComponent,
      PosFooterComponent,
      PoslayoutComponent,
      PosSidebarComponent
  ],
   imports: [
    SharedModule,   
    CommonModule,
    RouterModule.forChild(routes),
    NgxSelectModule,
    NgxDatatableModule,
    FormsModule,
    LayoutModule
    // Ng2TableModule,,
   
  ],
  providers: [    

  ],
  exports: [
    RouterModule
]
})
export class PoslayoutModule { }